// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Time__time-c9017d {
  --time-text-color: var(--chat-bubble-text-secondary);
  color: var(--time-text-color);
  font: var(--font-caption-1);
  letter-spacing: var(--font-spacing-caption-1);
  white-space: nowrap;
}

.Time__fixed-color-f1ec1d {
  --time-text-color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/StatusBar/Time/styles.m.css"],"names":[],"mappings":"AAAA;EACE,oDAAA;EACA,6BAAA;EACA,2BAAA;EACA,6CAAA;EACA,mBAAA;AACF;;AAEA;EACE,qCAAA;AACF","sourcesContent":[".time {\n  --time-text-color: var(--chat-bubble-text-secondary);\n  color: var(--time-text-color);\n  font: var(--font-caption-1);\n  letter-spacing: var(--font-spacing-caption-1);\n  white-space: nowrap;\n}\n\n.fixed-color {\n  --time-text-color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"time": `Time__time-c9017d`,
	"fixed-color": `Time__fixed-color-f1ec1d`,
	"fixedColor": `Time__fixed-color-f1ec1d`
};
module.exports = ___CSS_LOADER_EXPORT___;
